import CryptoJS from "crypto-js";

const secretKey = "MNufzq8wCtz0VHLn9uFB34zF5Xk5PxMt9oUb7Tyeq3gnPfbuXzwP33Jq6Y3nt8zahrdizVMHxkLzWgLuxZ";

export default {
  /**
   * 接口数据加密函数
   * @param str string 需加密的json字符串
   * @param key string 加密key(16位)
   * @param iv string 加密向量(16位)
   * @return string 加密密文字符串
   */
  encrypt(str, key, iv) {
    //密钥16位
    key = CryptoJS.enc.Utf8.parse(key);
    //加密向量16位
    iv = CryptoJS.enc.Utf8.parse(iv);
    var encrypted = CryptoJS.AES.encrypt(str, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    });
    return encrypted.toString();
  },
  generateSign(params) {
    // 将参数按照键名排序
    const sortedParams = Object.keys(params)
      .sort()
      .reduce((acc, key) => {
        acc[key] = params[key];
        return acc;
      }, {});

    // 将排序后的参数拼接成字符串
    let paramString = "";

    for (const key in sortedParams) {
      if (sortedParams[key] !== undefined && sortedParams[key] !== null) {
        if (paramString.length > 0) {
          paramString += "&";
        }
        // 检查值是否为对象（字典）或数组
        if (typeof sortedParams[key] === "object") {
          // 将对象或数组转换为 JSON 字符串，并进行 URL 编码
          paramString += `${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(sortedParams[key]))}`;
        } else {
          // 直接拼接字符串值
          paramString += `${encodeURIComponent(key)}=${encodeURIComponent(sortedParams[key])}`;
        }
      }
    }

    console.log(paramString);
    // 使用 HMAC-SHA256 生成签名
    const sign = CryptoJS.HmacSHA256(paramString, secretKey).toString(CryptoJS.enc.Hex);
    return sign;
  },
};
